import { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import { RouteSource } from '@monorepo/shared/src/graph/schema-generated-types-educator';

type Props = PropsWithChildren<
  {
    variant?: 'contained' | 'outlined';
    to: string;
    from?: RouteSource;
  } & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
>;

const ButtonStyledLink: React.FC<Props> = ({ to, from, children, ...props }) => {
  const classes = useStyles({ variant: props.variant ?? '' });
  return (
    <Link
      className={`${classes.button} ${props?.className ?? ''}`}
      to={{ pathname: to }}
      state={{ from }}
    >
      {children}
    </Link>
  );
};

const useStyles = makeStyles((theme) => ({
  button: {
    display: 'flex',
    alignItems: 'center',
    padding: '5px 10px',
    border: `solid 2px ${theme.palette.primary.main}`,
    borderRadius: 6,
    color: (props: any) => (props.variant === 'contained' ? '#fff' : theme.palette.primary.main),
    fontWeight: 'bold',
    backgroundColor: (props: any) =>
      props.variant === 'contained' ? theme.palette.primary.main : 'unset',
    textDecoration: 'none',
  },
}));
export default ButtonStyledLink;
